import { useLocation, useParams } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";
import { usePunditUserContext } from "@circle-react/contexts";
import { botBuilderNavPaths } from "@circle-react/helpers/urlHelpers/botBuilderNavPaths";
import type { SidebarLink } from "./types";

interface BotParams {
  botPublicId: string;
}

export const useCollapsedSidebarLinks = (): SidebarLink[] => {
  const { currentCommunityMember, currentCommunitySettings } =
    usePunditUserContext();
  const { botPublicId } = useParams<BotParams>();
  const pathname = useLocation().pathname;
  const isActive = (path: string) => pathname.includes(path);

  return [
    {
      label: t("community_bot.bot_builder.customize_page.title"),
      icon: isActive(
        botBuilderNavPaths.customize({
          botPublicId,
        }),
      )
        ? "20-bot-customize-active"
        : "20-bot-customize",
      path: botBuilderNavPaths.customize({
        botPublicId,
      }),
      enabled: isCommunityAdmin(currentCommunityMember),
    },
    {
      label: t("community_bot.bot_builder.audience_page.title"),
      icon: isActive(
        botBuilderNavPaths.audience({
          botPublicId,
        }),
      )
        ? "20-audience-active"
        : "20-audience",
      path: botBuilderNavPaths.audience({
        botPublicId,
      }),
      enabled: isCommunityAdmin(currentCommunityMember),
    },
    {
      label: t("community_bot.bot_builder.behavior_page.title"),
      icon: "20-bot-behavior",
      path: botBuilderNavPaths.behavior({
        botPublicId,
      }),
      enabled: isCommunityAdmin(currentCommunityMember),
    },
    {
      label: t("community_bot.bot_builder.knowledge_page.title"),
      icon: isActive(
        botBuilderNavPaths.knowledge({
          botPublicId,
        }),
      )
        ? "20-bot-content-active"
        : "20-bot-content",
      path: botBuilderNavPaths.knowledge({
        botPublicId,
      }),
      enabled: isCommunityAdmin(currentCommunityMember),
    },
    {
      label: t("community_bot.bot_builder.automations_page.title"),
      icon: isActive(
        botBuilderNavPaths.automations({
          botPublicId,
        }),
      )
        ? "20-automation-cursor-active"
        : "20-automation-cursor",
      path: botBuilderNavPaths.automations({
        botPublicId,
      }),
      enabled:
        isCommunityAdmin(currentCommunityMember) &&
        Boolean(currentCommunitySettings?.ai_automations_enabled),
    },
  ];
};
